import "./DoctorsGridPageCss/DoctorCard.css";
import { FaStar, FaHeart, FaMapMarkerAlt } from "react-icons/fa";
import { LuBookText, LuDot } from "react-icons/lu";
import { useEffect, useState } from "react";
import DoctorDetailsPage from "./DoctorDetailsPage";
import defaultImg from "../../Assets/doctor_default_copy.jpeg";
import { ImLocation2 } from "react-icons/im";
import { FaRegStar, FaStarHalfAlt } from "react-icons/fa";

import pngLogo from "../../Assets/rbdLogo.png";

import { BiLink } from "react-icons/bi";
import { TruncateText } from "../../common/TruncateText";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FiPhoneCall } from "react-icons/fi";
import { FaUserMd, FaStethoscope, FaBriefcaseMedical } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import { toCamelCase } from "../../utils/helper";

export default function DoctorCard({ params }) {
  console.log("chk dr params", params);
  const [liked, setLiked] = useState(false);
  //   const [available, setAvailable] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const navigator = useNavigate();

  // console.log(params.id)

  //   useEffect(() => {
  //       setAvailable(params.availability);
  //   }, [params.availability]);

  const handleLikedBtn = (e) => {
    e.stopPropagation();
    setLiked((prev) => !prev);
  };

  const handleBookNow = (doctorInfo) => {
    console.log(doctorInfo);

    navigator("/appointment/date-and-time", { state: { doctor: doctorInfo } });
  };

  const handleViewProfile = (e) => {
    setShowModal(true);
  };
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={i} color="#FFD700" />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" color="#FFD700" />);
    }
    while (stars.length < 5) {
      stars.push(<FaRegStar key={`empty-${stars.length}`} color="#ccc" />);
    }
    return stars;
  };

  const handleCloseModal = () => setShowModal(false);

  const [copyText, setCopyText] = useState("Copy OPD Link");

  // const handleCopyLink = (doctorId) => {
  //   const baseUrl = "https://rbdiagnostic.com";
  //   const formattedDoctorId = doctorId.trim().replace(/\s+/g, "_");
  //   const link = `${baseUrl}/doctor-booking?id=${formattedDoctorId}`;

  //   // ✅ Create hidden input and copy value
  //   const input = document.createElement("input");
  //   input.value = link;
  //   document.body.appendChild(input);
  //   input.select();
  //   document.execCommand("copy");
  //   document.body.removeChild(input);

  //   setCopyText("Copied!");
  //   setTimeout(() => setCopyText("Copy OPD Link"), 2000);
  // };

  // const handleCopyLink = (doctorId) => {
  //   if (!doctorId) {
  //     toast.error("Invalid doctor ID");
  //     return;
  //   }

  //   const doctorLink = `${window.location.origin}/rbweb-react/doctor/${doctorId}`;

  //   navigator.clipboard.writeText(doctorLink)
  //     .then(() => {
  //       setCopyText("Copied!");
  //       setTimeout(() => setCopyText("Copy OPD Link"), 2000);
  //     })
  //     .catch((err) => {
  //       console.error("Copy failed", err);
  //       toast.error("Copy failed");
  //     });
  // };

  // const handleCopyLink = (doctorId) => {
  //   const link = `${window.location.origin}/rbweb-react/doctor/${doctorId}`

  //   if (navigator.clipboard && navigator.clipboard.writeText) {
  //     navigator.clipboard.writeText(link)
  //       .then(() => {
  //         setCopyText('Copied');
  //         setTimeout(() => setCopyText("Copy OPD Line"), 2000);
  //       })
  //       .catch((err) => {
  //         console.error("Clipboard copy failed:", err)
  //       })
  //   } else {
  //     const textArea = document.createElement("textarea");
  //     textArea.value = link;
  //     document.body.appendChild(textArea);
  //     textArea.select();
  //     try {
  //       document.execCommand("copy");
  //       setCopyText('Copied');
  //       setTimeout(() => setCopyText('Copy OPD Link'), 2000);
  //     } catch (err) {
  //       console.error("Fallback: Copy failed", err);
  //     }
  //     document.body.removeChild(textArea);
  //   }
  // }

  const handleCopyLink = (doctor) => {
    // alert(doctor?.doctor_name)
    if (!doctor?.doctor_name) {
      toast.error("Invalid doctor ID");
      return;
    }

    // Clean ID slug
    const cleanId = String(doctor.doctor_name).trim().replace(/\s+/g, "_");

    // Final OPD link
    // const link = `${window.location.origin}/RBD/doctor/${cleanId}`;

    // const link = `${window.location.origin}/rbweb-react/doctor/${cleanId}`;
    const link = `${window.location.origin}/doctor/${cleanId}`

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(link)
        .then(() => {
          setCopyText("Copied!");
          setTimeout(() => setCopyText("Copy OPD Link"), 2000);
        })
        .catch((err) => {
          console.error("Clipboard error:", err);
          toast.error("Copy failed");
        });
    } else {
      // Fallback for older browsers
      const textarea = document.createElement("textarea");
      textarea.value = link;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        setCopyText("Copied!");
        setTimeout(() => setCopyText("Copy OPD Link"), 2000);
      } catch (err) {
        console.error("Fallback: Copy failed", err);
        toast.error("Copy failed");
      }
      document.body.removeChild(textarea);
    }
  };

  const getValidFee = (centers = []) => {
    if (!Array.isArray(centers) || centers.length === 0) return null;

    const validFees = centers
      .map((c) => Number(c.Fees))
      .filter((fee) => !isNaN(fee) && fee > 100); // ✅ strictly greater than 100

    if (validFees.length === 0) return null;

    return Math.min(...validFees);
  };
  //  const handlePhoneClick = (e) => {
  //   e.stopPropagation();
    
  //   const phoneNumber = "03340854085";
    
  //   // Try to copy to clipboard
  //   if (navigator.clipboard && navigator.clipboard.writeText) {
  //     navigator.clipboard.writeText(phoneNumber).then(() => {
  //       toast.success(`Phone number ${phoneNumber} copied to clipboard!`);
  //     }).catch(() => {
  //       toast.success(`Call us at: ${phoneNumber}`);
  //     });
  //   } else {
  //     // Fallback for older browsers
  //     const textArea = document.createElement("textarea");
  //     textArea.value = phoneNumber;
  //     document.body.appendChild(textArea);
  //     textArea.select();
  //     try {
  //       document.execCommand("copy");
  //       toast.success(`Phone number ${phoneNumber} copied to clipboard!`);
  //     } catch {
  //       toast.success(`Call us at: ${phoneNumber}`);
  //     }
  //     document.body.removeChild(textArea);
  //   }
  // };

  return (
    <>
      <div className="doctor-card">
        {/* <img className="RBDlogo-doctor" src={pngLogo} alt="RBD LOGO" /> */}
        <div className="dc-vf-bg">
          {params?.doctorVerificationStatus === "1" && (
            <div className="verified-badge">
              <span className="verified-icon">✔</span>
              <span className="verified-text">
                Medical Registration Verified
              </span>
            </div>
          )}
        </div>
        <div
          className="doctor-header"
          // onClick={handleBookNow}
          // onClick={handleViewProfile}
        >

          <div className="doctor-image-wrap">
            <img
              src={
                params?.DoctorPictureUrl ? params.DoctorPictureUrl : defaultImg
              }
              alt={params?.doctor_name}
              className="doctor-image"
            />

            {/* Overlay Logo */}
            <img src={pngLogo} alt="RBD LOGO" className="RBDlogo-doctor" />
          </div>

          <div className="doctorBasicDetails">
            <h3 className="doctor-name">
              Dr. {toCamelCase(params?.doctor_name)}
            </h3>

           

              <div className="doctor-subDetails">
                <p className="doctor-text">
                  <FaStethoscope style={{ marginRight: 6 }} />
                  {params?.specialization}
                </p>

                <p className="doctor-text">
                  <MdWork style={{ marginRight: 6 }} />
                  <TruncateText text={params?.Designation} maxLength={20} />
                </p>
                {params?.experience > 0 && (
                  <p className="doctor-text">
                    {" "}
                    <FaBriefcaseMedical style={{ marginRight: 6 }} />
                    {params?.experience} Years of Exp
                  </p>
                )}


                <div className="doctor-text locationMark">
                  <ImLocation2 />
                  {params?.centers
                    ?.map((center) => center.center_name)
                    .join(", ") || "NA"}
                </div>
              </div>
            </div>
          


        </div>
                  <div className="doctor-details">
            {/* <div className="doctor-speciality">
            <span className="speciality-tag">{params?.Designation}</span>
          </div> */}
            <div className="doctor-meta">
              {/* <p
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <strong>{params?.experience}+ yrs</strong> Experience
            </p> */}
              <div className="review-card-Div">
                {Number(params?.avgRating) > 0 &&
                  renderStars(Number(params.avgRating))}
              </div>

              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  color: "#333",
                }}
              >
                ₹{getValidFee(params?.centers)}/-
              </p>
            </div>
            <div className="copyLink" onClick={() => handleCopyLink(params)}>
              <p>
                <BiLink /> {copyText}{" "}
              </p>
              <div className="contactPill">
                <FiPhoneCall className="contactIcon" />
                <a 
                  href="tel:03340854085" 
                  className="contactNumber"
                  onClick={(e) => e.stopPropagation()}
                >
                  033 4085 4085
                </a>
              </div>
              {/* <div className="locationMark">
  <ImLocation2 />
  <TruncateText
    text={
      params?.centers?.map((center) => center.center_name).join(", ") || "NA"
    }
    maxLength={12}
  />
</div> */}
            </div>
            {/* <div className="doctor-actions">
           
            <button
              className="rbdButton book-btn"
              onClick={() =>
                navigator(`/doctor/${params.doctor_id}`, { state: { doctor: params } })
              }
            >
              View Profile
            </button>
            <button
              className="rbdButton book-btn"
              onClick={() => handleBookNow(params)}
            >
              <span className='btn-text'>Book</span>
            </button>
          </div> */}
            <div className="doctor-actions">
              <button
                className="rbdButton opd-btn"
                onClick={() =>
                  navigator(`/doctor/${params.doctor_id}`, {
                    state: { doctor: params },
                  })
                }
              >
                <span className="btn-text">View Profile</span>
              </button>
              <button
                className="rbdButton addCartBtn opd-btn"
                onClick={() => handleBookNow(params)}
              >
                <span className="btn-text">Book</span>
              </button>
            </div>
          </div>

        {showModal && (
          <DoctorDetailsPage doctor={params} onClose={handleCloseModal} />
        )}
      </div>
    </>
  );
}
